import React from "react";
import HeadingComponent from "@/components/Molecules/Heading/V1";

import { IngredientBox, IngredientWrapper, IngredientItem } from "./style";

function IngredientsComponent({ data = {} }) {
  return (
    <IngredientWrapper>
      <HeadingComponent
        title={data?.ingredientHeading}
        m="0 0 24px 0"
        variant="heading4"
      />
      <IngredientBox>
        {data?.ingredient?.map((ingredient) => (
          <IngredientItem
            key={ingredient.id}
            variant="label1"
            textTransform="capitalize"
          >
            {ingredient.title}
          </IngredientItem>
        ))}
      </IngredientBox>
    </IngredientWrapper>
  );
}

export default IngredientsComponent;
